import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';

const propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  background: PropTypes.string,
  loadPage: PropTypes.func,
  theme: PropTypes.object
};

const defaultProps = {
  currentPage: 0,
  totalPages: 0,
  background: '#103a60'
};

const GridPager = props => {
  const {
    gridPagerBackground,
    gridPagerTopBorderColor,
    gridPagerTextColor,
    gridPagerFontSize,
    gridPagerDropdownTextColor,
    gridPagerIconsTextColor,
    gridPagerIconsBackground,
    gridPagerHeight
  } = props.theme;

  const styles = StyleSheet.create({
    gridPager: {
      display: 'flex',
      marginBottom: '8px',
      justifyContent: 'flex-end',
      alignItems: 'center',
      background: gridPagerBackground,
      borderTop: `1px solid ${gridPagerTopBorderColor}`,
      color: gridPagerTextColor,
      fontSize: gridPagerFontSize,
      height: `${gridPagerHeight}px`
    },
    pagerBtn: {
      // background: gridPagerIconsBackground,
      // color: gridPagerIconsTextColor,
      color: gridPagerIconsBackground,
      // borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      width: '24px',
      height: '24px',
      fontSize: '18px'
    }
  });

  return (
    <div className={`pt-1 pb-1 pr-1 ${css(styles.gridPager)}`}>
      {/* First page */}
      <div
        className={`noselect ${css(styles.pagerBtn)}`}
        style={{ marginRight: '4px' }}
        onClick={() => {
          if (props.totalPages > 0) {
            props.loadPage(1);
          }
        }}
      >
        <i className="fa fa-angle-double-left" />
      </div>

      {/* Previous page */}
      <div
        className={`noselect ${css(styles.pagerBtn)}`}
        style={{ marginRight: '8px' }}
        onClick={() => {
          if (props.totalPages > 0) {
            const page = (props.currentPage - 1) > 1 ? props.currentPage - 1 : 1;
            props.loadPage(page);
          }
        }}
      >
        <i className='fa fa-angle-left' />
      </div>

      {/* Current page of total */}
      <div>
        {props.totalPages <= 0
          ? 'No Results'
          : `Page ${(props.currentPage).toLocaleString()} of ${(props.totalPages).toLocaleString()}`
        }
      </div>

      {/* Next page */}
      <div
        className={`noselect ${css(styles.pagerBtn)}`}
        style={{ marginLeft: '8px', marginRight: '4px', fontSize: '16px' }}
        onClick={() => {
          if (props.totalPages > 0) {
            const page = (props.currentPage + 1) <= props.totalPages
              ? props.currentPage + 1
              : props.totalPages;
            props.loadPage(page);
          }
        }}
      >
        <i className='fa fa-angle-right' />
      </div>

      {/* Last page */}
      <div
        className={`noselect ${css(styles.pagerBtn)}`}
        onClick={() => {
          if (props.totalPages > 0) {
            props.loadPage(props.totalPages);
          }
        }}
      >
        <i className='fa fa-angle-double-right' />
      </div>
    </div>
  );
};

GridPager.propTypes = propTypes;
GridPager.defaultProps = defaultProps;

export { GridPager };
